import { useState } from 'react';

interface VariationFilterProps {
  value?: string;
  onChange: (value: string | undefined) => void;
}

interface VariationType {
  id: number;
  label: string;
  values: string[];
}

const VARIATION_TYPES: VariationType[] = [
  {
    id: 0,
    label: 'Faixa Etária',
    values: ['1', '2', '4', '6', '8', '10', '12', '14'],
  },
  {
    id: 1,
    label: 'Tamanho',
    values: ['PP', 'P', 'M', 'G', 'GG', 'XG', 'XXG'],
  },
  {
    id: 2,
    label: 'Kit',
    values: ['3', '5', '7', '10'],
  },
  {
    id: 3,
    label: 'Calçado',
    values: [
      '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28',
      '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42',
      '43', '44',
    ],
  },
  {
    id: 4,
    label: 'Acessório',
    values: [
      'Tamanho Único',
      'Boné',
      'Chapéu',
      'Gigolete',
      'Tiara',
      'Presilha',
      'Laço de cabelo',
      'Óculos de sol',
    ],
  },
];

export function VariationFilter({ value, onChange }: VariationFilterProps) {
  const [selectedTypeId, setSelectedTypeId] = useState<number | null>(() => {
    if (value === undefined) return null;
    const match = VARIATION_TYPES.find((t) => t.values.includes(value));
    return match ? match.id : null;
  });

  const selectedType = selectedTypeId !== null
    ? VARIATION_TYPES.find((t) => t.id === selectedTypeId) ?? null
    : null;

  const handleTypeSelect = (typeId: number) => {
    if (selectedTypeId === typeId) {
      setSelectedTypeId(null);
      onChange(undefined);
    } else {
      setSelectedTypeId(typeId);
      onChange(undefined);
    }
  };

  const handleValueSelect = (val: string) => {
    if (value === val) {
      onChange(undefined);
    } else {
      onChange(val);
    }
  };

  const handleClear = () => {
    setSelectedTypeId(null);
    onChange(undefined);
  };

  return (
    <div className="w-full md:w-64 flex-shrink-0">
      <div className="bg-white rounded-xl shadow-sm p-4 sticky top-20">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2 text-sm font-semibold text-text-dark">
            Variação
            {value !== undefined && (
              <span className="bg-chocolate text-white text-xs w-5 h-5 rounded-full flex items-center justify-center font-medium">
                1
              </span>
            )}
          </div>
          <button
            onClick={handleClear}
            disabled={selectedTypeId === null && value === undefined}
            className="flex items-center gap-1 text-xs text-text-light hover:text-chocolate transition-colors disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:text-text-light"
          >
            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
            </svg>
            Limpar
          </button>
        </div>

        <div className="flex flex-wrap gap-1.5 mb-4">
          {VARIATION_TYPES.map((type) => (
            <button
              key={type.id}
              type="button"
              onClick={() => handleTypeSelect(type.id)}
              className={[
                'px-2.5 py-1 rounded-full text-xs border transition-colors',
                selectedTypeId === type.id
                  ? 'bg-champagne border-chocolate text-chocolate font-medium'
                  : 'border-champagne-dark text-text-medium hover:border-chocolate/60 hover:text-text-dark',
              ].join(' ')}
            >
              {type.label}
            </button>
          ))}
        </div>

        {selectedType && (
          <div className="flex flex-wrap gap-1.5">
            {selectedType.values.map((val) => (
              <button
                key={val}
                type="button"
                onClick={() => handleValueSelect(val)}
                className={[
                  'px-2.5 py-1 rounded-full text-xs border transition-colors',
                  value === val
                    ? 'bg-champagne border-chocolate text-chocolate font-medium'
                    : 'border-champagne-dark text-text-medium hover:border-chocolate/60 hover:text-text-dark',
                ].join(' ')}
              >
                {val}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
